<template>
	<div class="flex flex-row items-center gap-[5px]">
		<span class="material-symbols-rounded text-success text-base">check_circle</span>
		<p class="text-xs text-success font-medium">{{message?.length ? message : defaultMessage }}</p>
	</div>
</template>

<script>
export default {
	name: "success-block",
	props: {
		message: String,
	},
	data() {
		return {
			defaultMessage: "Success"
		}
	}
}
</script>

<style>

</style>